import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import type * as React from 'react';

interface Props {
  openDialog: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
  header: string;
  description: string;
  extraContent?: React.ReactNode;
  children: React.ReactNode;
}

const OptionsDialog: React.FC<Props> = ({
  openDialog: open,
  setOpenDialog,
  header,
  description,
  extraContent,
  children,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => setOpenDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{header}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">{description}</DialogContentText>
        {extraContent}
      </DialogContent>
      <DialogActions>{children}</DialogActions>
    </Dialog>
  );
};

export default OptionsDialog;
